import React, { useState, useEffect } from "react";
import TrSelectPagedList from "../../models/shared/TrSelectPagedList";

const useTable = (fullDataList?: TrSelectPagedList[]) => {
  const [page, setPage] = useState(0);
  const [pageSize, setpageSize] = useState(50);
  const [fullDataListState, setFullDataListState] = useState<
    TrSelectPagedList[]
  >(new Array<TrSelectPagedList>());

  useEffect(() => {
    let newList = [...fullDataListState];
    if (fullDataList) {
      fullDataList.forEach(i => {
        const stateItem = fullDataListState.find(si => si.id == i.id);
        if (stateItem == undefined) {
          newList.push(i);
        }
      });
      setFullDataListState(newList);
    }
  }, [fullDataList]);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangepageSize = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setpageSize(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleTableSelectChange = (id: number, selected: boolean) => {
    if (fullDataListState != null && fullDataListState.length > 0) {
      let item = fullDataListState.find(i => i.id == id);
      if (item != null && item.isEnabled) {
        let newList = fullDataListState.map(i => {
          if (i.id == item!.id) {
            return { ...i, isSelected: selected };
          }
          return i;
        });
        setFullDataListState(newList);
      }
    }
  };

  const handleTableAllSelectChange = (selected: boolean) => {
    if (fullDataListState != null && fullDataListState.length > 0) {
      fullDataListState.forEach(item => {
        if (item.isEnabled) {
          let newList = fullDataListState.map(i => {
            return { ...i, isSelected: selected };
          });
          setFullDataListState(newList);
        }
      });
    }
  };

  const getAllSelectedListItems = () => {
    const allSeleceted = fullDataListState.filter(i => i.isSelected);
    if (allSeleceted && allSeleceted.length > 0) {
      return allSeleceted.map(i => {
        return i.id;
      });
    }
  };

  const getAllSelectedLength = () => {
    const allSeleceted = fullDataListState.filter(
      i => i.isSelected && i.isEnabled
    );
    return allSeleceted.length;
  };

  const allItemsSelected = () => {
    return fullDataListState.find(i => !i.isSelected && i.isEnabled) == null;
  };

  const handleResetDataList = (fullDataList: TrSelectPagedList[]) => {
    setFullDataListState(fullDataList);
  };

  return {
    page,
    pageSize,
    handleChangePage,
    handleChangepageSize,
    handleTableSelectChange,
    handleTableAllSelectChange,
    getAllSelectedListItems,
    getAllSelectedLength,
    allItemsSelected,
    handleResetDataList
  };
};

export default useTable;
